import { module } from 'angular';

import { default as domainDashboardName, DomainDashboard } from './domain-dashboard.component.ajs';

export default module('hypervision.synthetic-view.domain-dashboard', []).component(domainDashboardName, new DomainDashboard()).name;
